export default "__VITE_ASSET__CEtAZESu__"